// Normalize an axios/FastAPI error into a renderable string. FastAPI's `detail`
// is a STRING for HTTPException(400, "msg"), an OBJECT for
// HTTPException(400, {code, message}), and a LIST of {loc, msg, type} rows for
// 422 validation errors — rendering a non-string as a JSX child crashes React
// ("Objects are not valid as a React child"), which with no error boundary used
// to white-screen the whole public page.
export default function errText(e, fallback) {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) {
    const msg = d.map((x) => x?.msg).filter(Boolean).join('; ');
    if (msg) return msg;
  }
  if (d && typeof d === 'object') {
    const m = d.message || d.msg || d.error;
    if (typeof m === 'string') return m;
  }
  return fallback;
}
